"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadGoogle = exports.googleApiKey = void 0;
var places;
var googleLoaded = -1;
var callbacks = [];
window.googleCallback = function () {
    googleLoaded = 1;
    places = new google.maps.places.PlacesService(document.createElement("div"));
    for (var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++) {
        var fn = callbacks_1[_i];
        fn(places);
    }
    callbacks = [];
};
exports.googleApiKey = "AIzaSyAe7OPI75YAVQ4oWWoeA3XTF52RIyDq2Pk";
var loadGoogle = function () {
    return new Promise(function (resolve) {
        if (googleLoaded < 0) {
            var scriptId = "googleMaps";
            var scriptExisting = document.getElementById(scriptId);
            if (!scriptExisting) {
                var script = document.createElement("script");
                script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(exports.googleApiKey, "&libraries=places&callback=googleCallback");
                script.id = scriptId;
                document.body.appendChild(script);
                googleLoaded = 0;
            }
            else {
                googleLoaded = 1;
                places = new google.maps.places.PlacesService(document.createElement("div"));
            }
        }
        if (googleLoaded == 0) {
            callbacks.push(resolve);
        }
        if (googleLoaded > 0) {
            resolve(places);
        }
    });
};
exports.loadGoogle = loadGoogle;
(0, exports.loadGoogle)();
//# sourceMappingURL=GoogleLoader.js.map